export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjM3MjI0YWQwLTJjMjktNGE2Yy1iOTAyLTJkMTdlZTBhODA2NSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.a9CJxUFpxL+QJIf3F275ef7vVBQ+QnnzpoAIseHcfYt8Io1KShbkztXRc1r+/NZlp5FoqXV5aPfbTAc7bQN/rTW27ACd1FM2VsJXE7Z8tNz4TxzxtVzEqtC6XhiEp8+TGR7Nzw==';

